//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {VueShowdown} from 'vue-showdown'
import ConfirmationDialog from "@/components/ConfirmationDialog";
export default {
  name: 'OrganizationsSelect',
  components: {ConfirmationDialog, VueShowdown},
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '',
    },
    scopes: {
      type: Object,
      default: () => ({})
    },
    blocks: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    currentSectionTitle() {
      let title = ''
      for (let block of this.blocks) {
        const tile = block.list.find(item => item.code === this.code)
        if (tile) {
          return tile.title
        }
      }
      return title
    }
  },
  data: () => ({
    activeTab: 'section',
    activeOrg: null,
    selectedOrg: {},
    names: {
      ru: 'shortName',
      en: 'shortNameEn',
    }
  }),
  mounted() {
    this.readFromLocalStorage()
    this.init()
    this.emitCurrentOrganizations()
  },
  watch: {
    opened(val) {
      if (val) {
        this.init()
      }
    },
    code() {
      this.emitCurrentOrganizations()
    },
  },
  methods: {
    init() {
      Object.entries(this.scopes).forEach(([key, value]) => {
        if (value && value.length && !this.selectedOrg[key]) {
          this.$set(this.selectedOrg, key, value[0].organizationId)
        }
      })
    },
    async toggleSelected(code, org) {
      if (org.organizationId !== this.selectedOrg[code]) {
        if (await this.$refs.confirm.confirm(this.$t('orgChangeConfirm'), this.$t('orgChangeConfirmText'))) {
          this.$set(this.selectedOrg, code, org.organizationId)
          if (this.code === code) {
            this.saveToLocalStorage(code, org)
            this.$emit('change-org', org)
          }
        }
      }
    },
    emitCurrentOrganizations() {
      let organization = null
      if (this.code && this.selectedOrg[this.code]) {
        organization = this.scopes[this.code].find(org => org.organizationId === this.selectedOrg[this.code])
      }
      this.$emit('change-org', organization)
    },
    readFromLocalStorage() {
      try {
        const data = JSON.parse(localStorage.getItem('moex-platform-organization'))
        if (Object.keys(data).length) {
          Object.entries(data).forEach(([code, org]) => {
            if (this.scopes[this.code].find(item => item.organizationId === org.organizationId)) {
              this.$set(this.selectedOrg, code, org.organizationId)
              if (this.code === code) {
                this.$emit('change-org', org)
              }
            }
          })
        }
        if (!this.selectedOrg[this.code]) {
          localStorage.removeItem('moex-platform-organization')
        }
      } catch (e) {
        //
      }
    },
    saveToLocalStorage(code, org) {
      try {
        const data = JSON.parse(localStorage.getItem('moex-platform-organization'))
        data[code] = org
        localStorage.setItem('moex-platform-organization', JSON.stringify(data))
      } catch (e) {
        const data = {
          [code]: org
        }
        localStorage.setItem('moex-platform-organization', JSON.stringify(data))
      }
    }
  }
}
